import React from "react"

export const CourseProductWarning = () => {
  return(
    <div className='alert product_warning stick_to_breadcrumb'>
      <ul className='list-inline'>
        <li className='warning-note'>
          Note:
        </li>
        <li className='warning-text-container'>
          Before editing a course and changing tee data, remember that these are permanent changes that will affect existing leagues / events / trips that use this course. If a course has been re-rated, we suggest that you rename the existing course, make a copy of the course, then edit this copy to reflect the changes.
        </li>
      </ul>
    </div>
  )
}